// stores/router.js
import { writable, derived } from "svelte/store";
import logger from "../utils/logger";

// Create a store for the current route
export const currentRoute = writable(window.location.hash || "#/");

// Parse the documentId from the route
export const routeDocumentId = derived(currentRoute, ($currentRoute) => {
  // Format: #/document/:id
  const match = $currentRoute.match(/^#\/document\/(\d+)$/);
  return match ? parseInt(match[1], 10) : null;
});

// Initialize the router
export function initRouter(routeChangeHandler, handleInitialRoute = true) {
  logger.info("Initializing router");

  // Register the route change handler if provided
  if (typeof routeChangeHandler === "function") {
    // Listen for hashchange events
    window.addEventListener("hashchange", () => {
      logger.debug("Hash change event", { hash: window.location.hash });
      currentRoute.set(window.location.hash);
      routeChangeHandler(window.location.hash);
    });

    // Handle initial route if requested
    if (handleInitialRoute) {
      logger.debug("Handling initial route", {
        hash: window.location.hash || "#/",
      });
      routeChangeHandler(window.location.hash || "#/");
    }
  }
}

// Navigation functions
export function navigateToDocument(documentId, silent = false) {
  const hash = `#/document/${documentId}`;
  logger.debug("Navigating to document", { documentId, hash, silent });

  if (window.location.hash !== hash) {
    if (silent) {
      // Update location without triggering hashchange event
      history.replaceState(null, "", hash);
      currentRoute.set(hash);
    } else {
      window.location.hash = hash;
      currentRoute.set(hash);
    }
  }
}

export function navigateToHome(silent = false) {
  logger.debug("Navigating to home", { silent });

  if (window.location.hash !== "#/") {
    if (silent) {
      // Update location without triggering hashchange event
      history.replaceState(null, "", "#/");
      currentRoute.set("#/");
    } else {
      window.location.hash = "#/";
      currentRoute.set("#/");
    }
  }
}

// Route parsing helper
export function parseDocumentId(hash) {
  const match = hash.match(/^#\/document\/(\d+)$/);
  return match ? parseInt(match[1], 10) : null;
}

// Check if a route is a document route
export function isDocumentRoute(hash) {
  return hash.startsWith("#/document/");
}

// Check if a route is the home route
export function isHomeRoute(hash) {
  return hash === "#/" || hash === "";
}
